import { User } from "@supabase/supabase-js";

interface UserInfoProps {
    user: User;
}

export const UserInfo = ({ user }: UserInfoProps) => (
    <div className="flex items-center gap-2">
        <span className="text-sm font-medium hidden sm:inline-block">
            {user.email}
        </span>
    </div>
);